import { Trans, useTranslation } from "react-i18next";
import allsafeLogo from "../assets/icons/allsafe_logo.svg";
import mikaBaumeister from "../assets/images/mika_baumeister_sm.jpg";

const Header = ({
  language,
  setLanguage,
}: {
	language: string;
	setLanguage: (val: string) => void;
}) => {
  const { i18n } = useTranslation();

  const handleLangChange = (e: any) => {
    const lang = e.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <header data-testid="header">
      <div className="fixed flex justify-between items-center bg-allsafe-white shadow-md w-full z-20 h-24 pl-4 pr-8">
        <div className="h-16 w-16">
          <img src={allsafeLogo} alt="logo" className="w-full h-full" />
        </div>
        <div className="relative overflow-hidden">
          <select
            name="lang"
            id="lang"
            onChange={handleLangChange}
            value={language}
            className="font-Roboto cursor-pointer w-16 h-8 bg-allsafe-grey hover:bg-gray-200 shadow-3xl appearance-none bg-[url('./assets/icons/arrow.svg')] bg-no-repeat	bg-[90%_50%] rounded-md outline-none indent-2"
          >
            <option value="de">DE</option>
            <option value="en">EN</option>
          </select>
        </div>
      </div>
      <div className="relative top-24 h-36 md:h-[405px]">
        <div className="h-full w-full absolute">
          <img
            className="w-full h-full object-cover "
            src={mikaBaumeister}
            alt="mikaBaumeister"
          />
        </div>
        <div className="bg-gradient-to-r from-[#5092CE] to-[#44444400] h-full w-full absolute top-0 mix-blend-multiply" />
        <div className="flex items-center w-full h-full absolute top-0 text-white text-4xl leading-10 font-bold font-Roboto pl-8 lg:pl-28 md:text-7xl md:leading-12 xl:text-8xl xl:leading-14">
          <Trans>CO2 reduziertes Aluminium?</Trans>
        </div>
      </div>
    </header>
  );
};

export default Header;
